import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../../theme";
import { Text } from "../../text";
export const TableOfContentsHeader = () => (_jsxs(Wrapper, { children: [_jsx(Text, { fontSize: "1.25em", fontWeight: "bold", children: "Table of Contents" }), _jsx(Text, { fontSize: "1.25em", fontWeight: "bold", children: "Status" })] }));
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.color.borderGray};
  padding: 0 2px 2em 2px;
`;
